document.addEventListener('DOMContentLoaded', function () {
    const reasonTypeSelect = document.getElementById('reason_type');
    const evidenceSection = document.getElementById('evidence-files-section');
    const evidenceInput = document.getElementById('evidence_files');
    const errorMessage = document.getElementById('evidence-files-error');

    if (!reasonTypeSelect || !evidenceSection) {
        return;
    }

    const SICKNESS_OR_INJURY = evidenceSection.dataset.sicknessOrInjury;
    const UNAVOIDABLENESS = evidenceSection.dataset.unavoidableness;
    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
    const MAX_FILE_COUNT = 5;

    function toggleEvidenceSection() {
        const value = reasonTypeSelect.value;
        if (value === SICKNESS_OR_INJURY || value === UNAVOIDABLENESS) {
            evidenceSection.style.display = '';
        } else {
            evidenceSection.style.display = 'none';
            if (evidenceInput) {
                evidenceInput.value = '';
            }
            hideError();
        }
    }

    function showError(message) {
        if (errorMessage) {
            errorMessage.textContent = message;
            errorMessage.style.display = '';
        }
    }

    function hideError() {
        if (errorMessage) {
            errorMessage.textContent = '';
            errorMessage.style.display = 'none';
        }
    }

    function validateFiles() {
        if (!evidenceInput || !evidenceInput.files.length) {
            hideError();
            return true;
        }

        var files = evidenceInput.files;

        if (files.length > MAX_FILE_COUNT) {
            showError('ファイルは最大' + MAX_FILE_COUNT + '個までアップロードできます。');
            evidenceInput.value = '';
            return false;
        }

        for (var i = 0; i < files.length; i++) {
            var file = files[i];

            if (file.type !== 'application/pdf') {
                showError('「' + file.name + '」はPDF形式ではありません。PDF形式のファイルをアップロードしてください。');
                evidenceInput.value = '';
                return false;
            }

            if (file.size > MAX_FILE_SIZE) {
                showError('「' + file.name + '」のファイルサイズが10MBを超えています。');
                evidenceInput.value = '';
                return false;
            }
        }

        hideError();
        return true;
    }

    reasonTypeSelect.addEventListener('change', toggleEvidenceSection);

    if (evidenceInput) {
        evidenceInput.addEventListener('change', validateFiles);
    }

    // フォーム送信時にもバリデーション
    var form = evidenceInput ? evidenceInput.closest('form') : null;
    if (form) {
        form.addEventListener('submit', function (e) {
            if (evidenceSection.style.display !== 'none' && !validateFiles()) {
                e.preventDefault();
            }
        });
    }

    // 初期表示時にも判定（バリデーションエラーで戻った場合）
    toggleEvidenceSection();
});
